export enum SpeakingType {
  DUB = 'DUB',
  ORG = 'ORG',
}
